import React from 'react';
import { steps } from '../../data/site';
import { SectionHeading } from '../ui/SectionHeading';
import { useBrand } from '../../contexts/BrandContext';
export function Steps() {
  const {
    text
  } = useBrand();
  return <section className="bg-cream-light" data-id="element-104" data-mp="pb6zkcgjulpg">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-105" data-mp="p8cbmaybuira">
        <SectionHeading eyebrow="How care works" title="Four steps, and you see the price before step three." intro="Republic is built so nothing ships and nothing is charged until a clinician has read your labs and you have approved the protocol in writing." data-id="element-106" data-mp="tca9yjftvpja" />

        <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-ink/10" data-id="element-107" data-mp="18053g21ntxxf">
          {steps.map((step, index) => <li key={step.label} className="lg:px-8 lg:first:pl-0 lg:last:pr-0" data-id="element-108" data-mp="3sqcp25mnjgca" data-mpi={index}>
              <div className="flex items-baseline justify-between" data-id="element-109" data-mp="1kl1ne09eht6">
                <span className="font-serif text-3xl text-brick" data-id="element-110" data-mp="1lw5texm9rkt">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-111" data-mp="2vpxcsjm4rbz6">
                  {step.duration}
                </span>
              </div>
              <div className="rule mt-4 pt-5" data-id="element-112" data-mp="3aklhhvjpi6dq">
                <h3 className="font-serif text-2xl leading-snug text-ink" data-id="element-113" data-mp="35nbq4acrbkn9">{step.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-114" data-mp="3jmkwyjf2p2ek">{text(step.detail)}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}